var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighDemandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44098 1.88197C3.86446 1.67023 4.37123 1.71593 4.75 2.00001L6.66667 3.43751L8.58333 2.00001C9.02778 1.66667 9.63889 1.66667 10.0833 2.00001L12 3.43751L13.9167 2.00001C14.3611 1.66667 14.9722 1.66667 15.4167 2.00001L17.3333 3.43751L19.25 2.00001C19.6288 1.71593 20.1355 1.67023 20.559 1.88197C20.9825 2.09371 21.25 2.52654 21.25 3.00001V16C21.25 18.8995 18.8995 21.25 16 21.25H8C5.10051 21.25 2.75 18.8995 2.75 16V3.00001C2.75 2.52654 3.0175 2.09371 3.44098 1.88197ZM5.25 5.50001V16C5.25 17.5188 6.48122 18.75 8 18.75H16C17.5188 18.75 18.75 17.5188 18.75 16V5.50001L18.0833 6.00001C17.6389 6.33334 17.0278 6.33334 16.5833 6.00001L14.6667 4.56251L12.75 6.00001C12.3056 6.33334 11.6944 6.33334 11.25 6.00001L9.33333 4.56251L7.41667 6.00001C6.97222 6.33334 6.36111 6.33334 5.91667 6.00001L5.25 5.50001Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4973 8.55812C16.3698 8.02678 15.8357 7.69938 15.3044 7.82684L13.3265 8.30131C12.7952 8.42877 12.4678 8.96283 12.5952 9.49417C12.707 9.96 13.1312 10.2691 13.5922 10.2523L12.1193 12.5534L10.7315 11.1471C10.5164 10.9291 10.2125 10.823 9.9084 10.8598C9.60434 10.8966 9.33447 11.0722 9.17759 11.3352L7.19839 14.6538C6.91851 15.1231 7.07205 15.7304 7.54134 16.0103C8.01063 16.2902 8.61795 16.1366 8.89784 15.6674L10.2217 13.4476L11.5807 14.8248C11.792 15.0389 12.0892 15.1452 12.3883 15.1138C12.6875 15.0824 12.9561 14.9166 13.1182 14.6632L15.2257 11.3707C15.4565 11.67 15.8492 11.8227 16.2404 11.7289C16.7718 11.6014 17.0992 11.0673 16.9717 10.536L16.4973 8.55812Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighDemandIcon);
export default __webpack_public_path__ + "static/media/highDemandIcon.f0b33e60.svg";
export { ForwardRef as ReactComponent };